import React from 'react'
import ReactStars from "react-rating-stars-component";
import './TestimonialMain.css'
import FilledStar from '../../assets/jpg/FilledStar.png'
import EmptyStar from '../../assets/jpg/EmptyStar.png'

const TestimonialTiles = (props) => {

    const numbers = [1 , 2 , 3 , 4 , 5]
    const data = numbers.map((number) => {
        if(number <= props.stars) {
            return <li style = {{marginRight : '14px'}}> <img src = {FilledStar} alt = 'Star'/> </li>
        }
        else {
            return <li> <img src = {EmptyStar} alt = 'Star'/> </li>
        }
    })

    return (
            <div className = 'TestImage mt-4 pb-3'> 
             <div className = 'TestElement   '> 
                <p>{props.para}</p>
                <a href={props.profile}><img src = {props.image}  alt = "profileImage" className = 'img-fluid myImage' /></a>
                <p className = 'TestEditText2' style = {{marginTop:"14px"}}>{props.myName} </p>
                <div className = 'TestStars'>
                <ul className="TestStarsData" style = {{display : 'flex' , flexDirection : 'row'}}> { data }
                </ul>
                </div> 
                <h1 className = 'TestEditText'>{props.designation} </h1>
                </div>
        </div>
    )
}

export default TestimonialTiles
